/* 
 *  Copyright (c) Intel Corporation.  All Rights Reserved.
 *
 * Registry accessor (read-only)
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { globalEngine, ModuleManager } from "./Init"
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";

// #ENDIF WebPack
function CreateRegistryHelper()
{ 
	var registry =
	{
		"openKey": function (hivePath, create)
		{
			if (typeof create !== "boolean")
			{
				create = false;
			}
			if (create)
			{
				logDebug("open registry in write mode");
				return this._getPlugin().CreateReg(hivePath);
			}
			logDebug("open registry in read mode");
			return this._getPlugin().OpenReg(hivePath);
		},
		"openKey64": function (hivePath, create)
		{
			if (typeof create !== "boolean")
			{
				create = false;
			}
			if (create)
			{
				logDebug("open registry in write mode (x64)");
				return this._getPlugin().CreateReg64(hivePath);
			}
			logDebug("open registry in read mode (x64)");
			return this._getPlugin().OpenReg64(hivePath);
		},
		"queryValue": function (name, obfuscated)
		{
			var isObfuscated = false;
			try
			{
				if (typeof obfuscated === "boolean")
				{
					isObfuscated = obfuscated;
				}
				var val = this._getPlugin().QueryValue(name, isObfuscated);
				return val;
			}
			catch (e)
			{
				// the plugin will throw an exception if the registry doesn't exist
				// might want this message turned off, or make it debug-only
				logInformation("Failed to query " + (isObfuscated ? "obfuscated " : "") + "registry key '" + name + "': exception is '" + e.message + "'");
			}
			return null;
		},
		"setValue": function(name, value, obfuscated)
		{
			var isObfuscated = false;
			try
			{
				if (typeof obfuscated === "boolean")
				{
					isObfuscated = obfuscated;
				}
				var response = this._getPlugin().SetValue(name, value, isObfuscated);
				if (!response) logDebug("registry.setvalue failed (" + name + ", " + value + ")");
				return response;
			}
			catch (e)
			{
				// might want this message turned off, or make it debug-only
				logInformation("Failed to set " + (isObfuscated ? "obfuscated" : "") + " registry key '" + hivePath + "\\" + name + " to '" + value + "': exception is '" + e.message + "'");
			}
			return null;
		},
		"executeAction": function(params)
		{
			 try
			{
				if (!params)
				{
					return null;
				}

			   if(!this._customActions)
			   {
					this._customActions = this._createCustomActions(this);
			   }
			   return this._customActions[params['action']](params);
			}
			catch (e)
			{
				logError('registry:custom_actions: ' + e.message + 'datadefinition(' + JSON.stringify(params['action']) + ')');
			}
			return null;
		},
		"fetchFromDataDefinition" : function (dataDefinition)
		{
			try
			{
				if (!dataDefinition)
				{
					logError('registry:fetchFromDataDefinition Invalid data definition');
					return null;
				}

				var path = dataDefinition['path'];
				var wow64_64 = (dataDefinition['wow64_64'] == true) ? true : false;

				var regKey;
				if (wow64_64 && registry._isWOW6432Node())
				{
					regKey = registry.openKey64(path);
				}
				else
				{
					regKey = registry.openKey(path);
				}


				if (!regKey)
				{
					logError('registry:fetchFromDataDefinition: Unable to open path (' + path + ')');
					return null;
				}
				var obfuscated = dataDefinition['obfuscated'];
				var valueName = dataDefinition['name'];
				return registry.queryValue(valueName, (obfuscated ? obfuscated : false));
			}
			catch (e)
			{
				logError('registry:fetchFromDataDefinition: ' + e.message + 'datadefinition(' + JSON.stringify(dataDefinition) + ')');
			}
			return null;
		},
		// 'private' (internal) stuff
		"_isWOW6432Node": function ()
		{
			try
			{
				return this.openKey('HKLM\\SOFTWARE\\WOW6432Node') == true;
			}
			catch(e)
			{
				logError('registry::_isWOW6432 ' + e.message);
			}
		},
		"_getPlugin": function ()
		{
			if (!this._regPlugin)
			{
				this._regPlugin = getPluginFactory().Create("registry");
			}
			return this._regPlugin;
		},
		"_createCustomActions": function(registryObject)
		{
			var actions =
			{
				"findbestpath":function(params)
				{
					var data =  params['data'];
					if(data instanceof Array)
					{
						for (var idx in data)
						{
							var value = registryObject.fetchFromDataDefinition(data[idx]);
							if (value) 
							{
								return value;
							}
						}
					} 
					return null;
				},
				"iterateapplist":function(params)
				{
					var appList = params['applist'];
					var appListPresent = [];
					if(appList instanceof Array)
					{
						var path = params['path'];
						for (var idx in appList)
						{
							//fixed shallow copy object to deepcopy
							//internal objects get modified due to shallow copy (should be copied)
							var inputParams = JSON.parse(JSON.stringify(params)); 
							inputParams['path'] = path +'\\'+appList[idx];
							if (registryObject.fetchFromDataDefinition(inputParams)) 
							{
								appListPresent.push(appList[idx]);
							}
						}
						return JSON.stringify(appListPresent);
					} 
					return null;
				}
			};
			return actions;
		},
		"_regPlugin": null,
		"_customActions": null  
	};
	return registry;
}

// register with the factory function with ModuleManager
ModuleManager.registerFactory("registry", CreateRegistryHelper);


//export  {CreateRegistryHelper};
//globalEngine.FactoryMap["registry"] =  CreateRegistryHelper;
